import { API_URL } from "config";
import Http from "util/https";
import {
  CSVCountCheckOrder,
  CSVManagedItem,
  CSVUploadCheckParam,
  CSVUploadCountParam,
  CSVUploadCountResponseApi,
} from "../types/index";
// import { csvStockList } from "./apiConstants";

/**
 * 店舗用注文商品一覧Api
 * @param params 注文商品一覧Apiのパラメータ
 * @returns CSVCountCheckOrder[]
 */
export default async function getCsvConfirmCheckApi(params: CSVUploadCheckParam) {
  console.log('getCsvConfirmCheckApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/csv/confirm`;
  const res = await http.post<CSVUploadCountResponseApi>(url, params);
  console.log(res);
  // const res: { data: SupplierStockSingle[] } = { data: csvStockList };

  // const objBase: CSVManagedItem = {
  //   item_cd: "000001",
  //   jan_cd: "000000000001",
  //   class_name: "タイヤ",
  //   vendor_name: "ブリヂストン",
  //   brand: "ボテンザ",
  //   item_name: "WH STA",
  //   size: "185/65R/15H",
  //   store_wholesale_price: 1000,
  //   errors: [],

  //   vendor_cd: "0001",
  //   depot_cd: "0000",
  //   item_cd: "0000",
  //   jan_cd: "0000000000001",
  //   quantity: -1,
  //   arrival_date: "",
  //   unused_depot_cd: false,
  //   error: "エラーがあります。修正してからもう一度アップロードしてください。"

  // };
  // const array: CSVManagedItem[] = [];
  // for (let i = 0; i < 10; i += 1) {
  //   const obj = { ...objBase };
  //   obj.jan_cd = `${i}`.padStart(4, "0");
  //   array.push(obj);
  // }

  // const res: { data: CSVUploadCountResponseApi } = {
  //   data: {
  //     process_id: "aaaa",
  //     total: 20,
  //     // errors: "アップロード失敗です。",
  //     managed_items: [],
  //     // list: array,
  //   },
  // };
  const stocks: CSVCountCheckOrder[] = res.data.managed_items.map((s) => {
    const stock: CSVCountCheckOrder = {
      item_cd: s.item_cd,
      jan_cd: s.jan_cd,
      class_name: s.class_name,
      vendor_name: s.vendor_name,
      brand: s.brand,
      item_name: s.item_name,
      size: s.size,
      store_wholesale_price: s.store_wholesale_price,
      // unusedStorehouseCd?: boolean;
      errors: s.errors ?? undefined,
    };
    // if ('unused_depot_cd' in s) stock.unusedStorehouseCd = s.unused_depot_cd;

    return stock;
  });

  await new Promise<void>((resolve) => {
    setTimeout(resolve, 1500);
  });
  // console.log(stocks);
  return stocks;
}
